/**
 * API Root url ...
 *
 * @type {string}
 */

export const BACKEND_API_ROOT = process.env.NEXT_PUBLIC_BACKEND_API_ROOT || 'http://localhost:8000/api';



/**
 * Blog ...
 */

export const BACKEND_EP_BLOG_POST_LIST = `${BACKEND_API_ROOT}/front-end/blog/posts/list`;
export const BACKEND_EP_BLOG_POST_DETAILS = `${BACKEND_API_ROOT}/front-end/blog/posts/details/`;
export const BACKEND_EP_BLOG_POST_DETAILS_SLUG = `${BACKEND_API_ROOT}/front-end/blog/posts/details-slug/`;
export const BACKEND_EP_BLOG_POST_FILTER_DATA = `${BACKEND_API_ROOT}/front-end/blog/filter-data`;

/**
 * Blog post attachment ...
 */

export const BACKEND_BLOG_POST_ATTACHMENT_DETAILS = `${BACKEND_API_ROOT}/blog/attachments/details/`;

/**
 * Business Insurance endpoints ...
 */

const BIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/business-insurance`;

export const BACKEND_BUSINESS_INSURANCE_QUOTE_NEW = `${BIS_ROOT}/new`;
export const BACKEND_BUSINESS_INSURANCE_QUOTE_DETAILS = `${BIS_ROOT}/details/`;
export const BACKEND_BUSINESS_INSURANCE_QUOTE_LIST = `${BIS_ROOT}/list`;
export const BACKEND_BUSINESS_INSURANCE_QUOTE_UPDATE = `${BIS_ROOT}/update/`;
export const BACKEND_BUSINESS_INSURANCE_QUOTE_TRASH = `${BIS_ROOT}/trash/`;
export const BACKEND_BUSINESS_INSURANCE_QUOTE_PURGE = `${BIS_ROOT}/purge/`;
export const BACKEND_BUSINESS_INSURANCE_QUOTE_RESTORE = `${BIS_ROOT}/restore/`;


/**
 * Car Insurance endpoints ...
 */

const CIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/car-insurance`;

export const BACKEND_CAR_INSURANCE_QUOTE_NEW = `${CIS_ROOT}/new`;
export const BACKEND_CAR_INSURANCE_QUOTE_DETAILS = `${CIS_ROOT}/details/`;
export const BACKEND_CAR_INSURANCE_QUOTE_LIST = `${CIS_ROOT}/list`;
export const BACKEND_CAR_INSURANCE_QUOTE_UPDATE = `${CIS_ROOT}/update/`;
export const BACKEND_CAR_INSURANCE_QUOTE_TRASH = `${CIS_ROOT}/trash/`;
export const BACKEND_CAR_INSURANCE_QUOTE_PURGE = `${CIS_ROOT}/purge/`;
export const BACKEND_CAR_INSURANCE_QUOTE_RESTORE = `${CIS_ROOT}/restore/`;

/**
 * Van Insurance endpoints ...
 */

const VIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/van-insurance`;

export const BACKEND_VAN_INSURANCE_QUOTE_NEW = `${VIS_ROOT}/new`;
export const BACKEND_VAN_INSURANCE_QUOTE_DETAILS = `${VIS_ROOT}/details/`;
export const BACKEND_VAN_INSURANCE_QUOTE_LIST = `${VIS_ROOT}/list`;
export const BACKEND_VAN_INSURANCE_QUOTE_UPDATE = `${VIS_ROOT}/update/`;
export const BACKEND_VAN_INSURANCE_QUOTE_TRASH = `${VIS_ROOT}/trash/`;
export const BACKEND_VAN_INSURANCE_QUOTE_PURGE = `${VIS_ROOT}/purge/`;
export const BACKEND_VAN_INSURANCE_QUOTE_RESTORE = `${VIS_ROOT}/restore/`;

/**
 * Taxi Insurance endpoints ...
 */

const TIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/taxi-insurance`;

export const BACKEND_TAXI_INSURANCE_QUOTE_NEW = `${TIS_ROOT}/new`;
export const BACKEND_TAXI_INSURANCE_QUOTE_DETAILS = `${TIS_ROOT}/details/`;
export const BACKEND_TAXI_INSURANCE_QUOTE_LIST = `${TIS_ROOT}/list`;
export const BACKEND_TAXI_INSURANCE_QUOTE_UPDATE = `${TIS_ROOT}/update/`;
export const BACKEND_TAXI_INSURANCE_QUOTE_TRASH = `${TIS_ROOT}/trash/`;
export const BACKEND_TAXI_INSURANCE_QUOTE_PURGE = `${TIS_ROOT}/purge/`;
export const BACKEND_TAXI_INSURANCE_QUOTE_RESTORE = `${TIS_ROOT}/restore/`;

/**
 * Motor Cycle Insurance endpoints ...
 */

const MCIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/motor-cycle-insurance`;

export const BACKEND_MOTOR_CYCLE_INSURANCE_QUOTE_NEW = `${MCIS_ROOT}/new`;
export const BACKEND_MOTOR_CYCLE_INSURANCE_QUOTE_DETAILS = `${MCIS_ROOT}/details/`;
export const BACKEND_MOTOR_CYCLE_INSURANCE_QUOTE_LIST = `${MCIS_ROOT}/list`;
export const BACKEND_MOTOR_CYCLE_INSURANCE_QUOTE_UPDATE = `${MCIS_ROOT}/update/`;
export const BACKEND_MOTOR_CYCLE_INSURANCE_QUOTE_TRASH = `${MCIS_ROOT}/trash/`;
export const BACKEND_MOTOR_CYCLE_INSURANCE_QUOTE_PURGE = `${MCIS_ROOT}/purge/`;
export const BACKEND_MOTOR_CYCLE_INSURANCE_QUOTE_RESTORE = `${MCIS_ROOT}/restore/`;

/**
 * Employer liability Insurance endpoints ...
 */

const ELIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/employer-liability-insurance`;

export const BACKEND_EMPLOYER_LIABILITY_INSURANCE_QUOTE_NEW = `${ELIS_ROOT}/new`;
export const BACKEND_EMPLOYER_LIABILITY_INSURANCE_QUOTE_DETAILS = `${ELIS_ROOT}/details/`;
export const BACKEND_EMPLOYER_LIABILITY_INSURANCE_QUOTE_LIST = `${ELIS_ROOT}/list`;
export const BACKEND_EMPLOYER_LIABILITY_INSURANCE_QUOTE_UPDATE = `${ELIS_ROOT}/update/`;
export const BACKEND_EMPLOYER_LIABILITY_INSURANCE_QUOTE_TRASH = `${ELIS_ROOT}/trash/`;
export const BACKEND_EMPLOYER_LIABILITY_INSURANCE_QUOTE_PURGE = `${ELIS_ROOT}/purge/`;
export const BACKEND_EMPLOYER_LIABILITY_INSURANCE_QUOTE_RESTORE = `${ELIS_ROOT}/restore/`;

/**
 * Fast food delivery Insurance endpoints ...
 */

const FFDIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/fast-food-delivery-insurance`;

export const BACKEND_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_NEW = `${FFDIS_ROOT}/new`;
export const BACKEND_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_DETAILS = `${FFDIS_ROOT}/details/`;
export const BACKEND_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_LIST = `${FFDIS_ROOT}/list`;
export const BACKEND_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_UPDATE = `${FFDIS_ROOT}/update/`;
export const BACKEND_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_TRASH = `${FFDIS_ROOT}/trash/`;
export const BACKEND_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_PURGE = `${FFDIS_ROOT}/purge/`;
export const BACKEND_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_RESTORE = `${FFDIS_ROOT}/restore/`;

/**
 * Home Insurance endpoints ...
 */

const HIS_ROOT = `${BACKEND_API_ROOT}/front-end/quote/home-insurance`;

export const BACKEND_HOME_INSURANCE_QUOTE_NEW = `${HIS_ROOT}/new`;
export const BACKEND_HOME_INSURANCE_QUOTE_DETAILS = `${HIS_ROOT}/details/`;
export const BACKEND_HOME_INSURANCE_QUOTE_LIST = `${HIS_ROOT}/list`;
export const BACKEND_HOME_INSURANCE_QUOTE_UPDATE = `${HIS_ROOT}/update/`;
export const BACKEND_HOME_INSURANCE_QUOTE_TRASH = `${HIS_ROOT}/trash/`;
export const BACKEND_HOME_INSURANCE_QUOTE_PURGE = `${HIS_ROOT}/purge/`;
export const BACKEND_HOME_INSURANCE_QUOTE_RESTORE = `${HIS_ROOT}/restore/`;

/**
 * Home Insurance endpoints ...
 */

const AMIS_ROOT = `${BACKEND_API_ROOT}/front-end/claim/accident-management-insurance`;

export const BACKEND_ACCIDENT_MANAGEMENT_CLAIM_NEW = `${AMIS_ROOT}/new`;
export const BACKEND_ACCIDENT_MANAGEMENT_CLAIM_DETAILS = `${AMIS_ROOT}/details/`;
export const BACKEND_ACCIDENT_MANAGEMENT_CLAIM_LIST = `${AMIS_ROOT}/list`;
export const BACKEND_ACCIDENT_MANAGEMENT_CLAIM_UPDATE = `${AMIS_ROOT}/update/`;
export const BACKEND_ACCIDENT_MANAGEMENT_CLAIM_TRASH = `${AMIS_ROOT}/trash/`;
export const BACKEND_ACCIDENT_MANAGEMENT_CLAIM_PURGE = `${AMIS_ROOT}/purge/`;
export const BACKEND_ACCIDENT_MANAGEMENT_CLAIM_RESTORE = `${AMIS_ROOT}/restore/`;

/**
 * Vehicle check ...
 */

export const BACKEND_VEHICLE_CHECK = `${BACKEND_API_ROOT}/vehicle/check`;